import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { sectionAnswerShape, translatableShape, aggregationShape } from '../../types';

const GTTableBody = (props) => {
  const {
    aggregation, question, renderScoreSelect, sectionId,
  } = props;
  const sampleIndexList = _.times(props.numSamples, (index) => `P${index + 1}`);
  return (
    <TableBody>
      {
        _.map(props.answers.oneOff.options, (option) => (
          <TableRow key={`${question}.${option.uuid}`}>
            <TableCell component="th" scope="row">
              {option.text}
            </TableCell>
            {
              _.map(_.keys(sampleIndexList), (sampleIndex, idx) => (
                <TableCell align="center" key={`${question.uuid}.${option.uuid}-${sampleIndex}`}>
                  {
                    aggregation
                    && renderScoreSelect(aggregation, idx, sectionId, question.uuid, option.uuid)
                  }
                </TableCell>
              ))
            }
          </TableRow>
        ))
      }
    </TableBody>
  );
};

const GTTable = (props) => {
  const {
    question, numSamples, section, type, additionalActionPerCase,
  } = props;
  const { caseNames } = section;
  return (
    <>
      <span className="f6 fw9">{`*${type}`}</span>
      <TableContainer component={Paper} elevation={0}>
        <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead className="bg-light-gray">
            <TableRow>
              <TableCell>{question.text}</TableCell>
              {_.times(numSamples, (index) => (
                <TableCell align="center" key={`sample-title-${index}`}>
                  {
                    additionalActionPerCase && additionalActionPerCase(index)
                  }
                  {(caseNames && caseNames[index]) || `P${index + 1}`}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <GTTableBody
            numSamples={props.numSamples}
            question={props.question}
            answers={props.answers}
            aggregation={props.aggregation}
            sectionId={props.sectionId}
            renderScoreSelect={props.renderScoreSelect}
          />
        </Table>
      </TableContainer>
    </>
  );
};

GTTable.defaultProps = {
  sectionId: undefined,
  aggregation: undefined,
  type: undefined,
  additionalActionPerCase: undefined,
};

GTTable.propTypes = {
  numSamples: PropTypes.number.isRequired,
  question: translatableShape.isRequired,
  answers: sectionAnswerShape.isRequired,
  aggregation: aggregationShape,
  section: PropTypes.shape({ caseNames: PropTypes.arrayOf(PropTypes.string) }).isRequired,
  sectionId: PropTypes.number,
  renderScoreSelect: PropTypes.func.isRequired,
  type: PropTypes.string,
  additionalActionPerCase: PropTypes.func,
};

export default GTTable;

GTTableBody.defaultProps = {
  aggregation: undefined,
  sectionId: undefined,
};

GTTableBody.propTypes = {
  numSamples: PropTypes.number.isRequired,
  question: translatableShape.isRequired,
  answers: sectionAnswerShape.isRequired,
  aggregation: aggregationShape,
  renderScoreSelect: PropTypes.func.isRequired,
  sectionId: PropTypes.number,
};
